import { render, staticRenderFns } from "./Order.component.vue?vue&type=template&id=6ffdddff&scoped=true&"
import script from "./Order.component.vue?vue&type=script&lang=js&"
export * from "./Order.component.vue?vue&type=script&lang=js&"
import style0 from "./Order.component.vue?vue&type=style&index=0&id=6ffdddff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffdddff",
  null
  
)

export default component.exports